module.exports = __webpack_public_path__ + "img/quard3.c9466173.png";